module.exports = __webpack_public_path__ + "static/media/coming_soon.f7ee184d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/coming_soon.svg
// module id = 869
// module chunks = 0